import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from "react-redux";
import {setNavigationViewType} from "../../../../actions/navigationFunctions";

class SelectionMobileViewSwitchers extends Component {

  static propTypes = {
    switchers: PropTypes.arrayOf(PropTypes.number).isRequired,
  };

  render() {
    return (
      <div className="menu-body__top-switchers">
        {this.props.switchers.includes(2) ? (
          <button className={"ui-switcher ui-switcher--2" + (this.props.navigationViewType === 2 ? " ui-switcher--active" : "")}
                  onClick={() => this.props.setNavigationViewType(2)}>
            <span/><span/>
          </button>
        ) : null}
        {this.props.switchers.includes(3) ? (
          <button className={"ui-switcher ui-switcher--3" + (this.props.navigationViewType === 3 ? " ui-switcher--active" : "")}
                  onClick={() => this.props.setNavigationViewType(3)}>
            <p><span/><span/><span/></p>
            <p><span/><span/><span/></p>
          </button>
        ) : null}
        {this.props.switchers.includes(4) ? (
          <button className={"ui-switcher ui-switcher--4" + (this.props.navigationViewType === 4 ? " ui-switcher--active" : "")}
                  onClick={() => this.props.setNavigationViewType(4)}>
            <p><span/><span/><span/><span/></p>
            <p><span/><span/><span/><span/></p>
          </button>
        ) : null}
      </div>
    )
  }
}

const mapStateToProps = (store) => ({
  navigationViewType: store.navigationState.navigationViewType,
});

const mapDispatchToProps = {
  setNavigationViewType
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectionMobileViewSwitchers);